import { render } from "./ItemsThreeView.vue?vue&type=template&id=5e41bcee&scoped=true"
import script from "./ItemsThreeView.vue?vue&type=script&lang=js"
export * from "./ItemsThreeView.vue?vue&type=script&lang=js"

import "./ItemsThreeView.vue?vue&type=style&index=0&id=5e41bcee&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e41bcee"]])

export default __exports__